"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.default=()=>{var n;const e="undefined"!=typeof window&&window.navigator.userAgent,i="undefined"!=typeof window&&(null!==(n=window.navigator.userAgentData&&window.navigator.userAgentData.platform)&&void 0!==n?n:window.navigator.platform);let o=null;return-1!==["Macintosh","MacIntel","MacPPC","Mac68K","macOS"].indexOf(i)?o="osx":-1!==["iPhone","iPad","iPod"].indexOf(i)?o="ios":-1!==["Win32","Win64","Windows","WinCE"].indexOf(i)?o="windows":/Android/.test(e)?o="android":!o&&/Linux/.test(i)&&(o="linux"),o};



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/calendars/~/@vds-core/utilities/cjs/components/DeviceDetection/getOperatingSystem.js
// module id = 894
// module chunks = 0